import React from 'react';
import {
  Box,
  VStack,
  Spinner,
  Text,
  Progress,
  Fade,
  ScaleFade
} from '@chakra-ui/react';

export const LoadingSpinner = ({
  size = "xl",
  message = "Loading...",
  showProgress = false,
  progress = 0,
  variant = "default"
}) => {
  const variants = {
    default: {
      spinner: { color: "blue.500" },
      text: { color: "gray.300" }
    },
    minimal: {
      spinner: { color: "blue.400", size: "md" },
      text: { color: "gray.400", fontSize: "sm" }
    },
    overlay: {
      spinner: { color: "white" },
      text: { color: "white" }
    }
  };

  const currentVariant = variants[variant] || variants.default;

  return (
    <ScaleFade initialScale={0.9} in={true}>
      <Box textAlign="center" py={variant === "minimal" ? 4 : 10}>
        <VStack spacing={4}>
          <Spinner
            size={variant === "minimal" ? "md" : size}
            {...currentVariant.spinner}
            thickness="3px"
            speed="0.8s"
          />

          {message && (
            <Fade in={true} delay={0.2}>
              <Text
                {...currentVariant.text}
                fontSize={variant === "minimal" ? "sm" : "md"}
                fontWeight="medium"
              >
                {message}
              </Text>
            </Fade>
          )}

          {showProgress && (
            <Fade in={true} delay={0.4}>
              <Box w="200px">
                <Progress
                  value={progress}
                  colorScheme="blue"
                  size="sm"
                  borderRadius="md"
                  bg="gray.700"
                />
                <Text fontSize="xs" color="gray.400" mt={1}>
                  {Math.round(progress)}% complete
                </Text>
              </Box>
            </Fade>
          )}
        </VStack>
      </Box>
    </ScaleFade>
  );
};

export const FullPageLoader = ({ message = "Loading application..." }) => (
  <Box
    position="fixed"
    top={0}
    left={0}
    right={0}
    bottom={0}
    bg="dark.900"
    display="flex"
    alignItems="center"
    justifyContent="center"
    zIndex={9999}
  >
    <LoadingSpinner message={message} variant="overlay" />
  </Box>
);

export const InlineLoader = ({ message = "Loading..." }) => (
  <LoadingSpinner message={message} variant="minimal" />
);

export const OverlayLoader = ({ isVisible, message = "Processing..." }) => (
  <Fade in={isVisible}>
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="blackAlpha.700"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="md"
      zIndex={1000}
    >
      <LoadingSpinner message={message} variant="overlay" />
    </Box>
  </Fade>
);

export default LoadingSpinner;
